import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Guid, Nillable } from '@web/utils';
import { AdminBoxSaleGroupCosmetic } from './admin-box-sale-group-cosmetic';
import { AdminBoxSaleMissingItemPickStrategy } from '../enums/admin-box-sale-missing-item-pick-strategy';

export type AdminBoxSaleGroupItem = {
  cosmetics: AdminBoxSaleGroupCosmetic[];
  description?: Nillable<string>;
  id?: Nillable<Guid>;
  isVisibleInQuestionnaire: boolean;
  missingItemPickStrategy: AdminBoxSaleMissingItemPickStrategy;
};

export class AdminBoxSaleGroups {
  public constructor(
    private readonly data: {
      items: AdminBoxSaleGroupItem[];
    },
  ) {}

  public get items(): AdminBoxSaleGroupItem[] {
    return this.data.items;
  }
}

export type AdminBoxSaleGroupFormGroup = FormGroup<{
  cosmetics: FormControl<AdminBoxSaleGroupCosmetic[]>;
  description: FormControl<Nillable<string>>;
  id: FormControl<Nillable<Guid>>;
  isVisibleInQuestionnaire: FormControl<boolean>;
  missingItemPickStrategy: FormControl<AdminBoxSaleMissingItemPickStrategy>;
}>;

export type AdminBoxSaleGroupsFormGroup = FormGroup<{
  groups: FormArray<AdminBoxSaleGroupFormGroup>;
}>;

export class AdminBoxSaleDetailsForm {
  public static DescriptionMaxLength = 10000;
  public static DefaultValidityHours = 24;

  public constructor(
    private readonly data: {
      canBeGroupsEdited: boolean;
      description?: Nillable<string>;
      groups?: Nillable<AdminBoxSaleGroups>;
      id?: Nillable<Guid>;
      validityHours?: number;
      warehouseProductId?: Nillable<Guid>;
    },
  ) {}

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get warehouseProductId(): Nillable<Guid> {
    return this.data.warehouseProductId;
  }

  public get canBeGroupsEdited(): boolean {
    return this.data.canBeGroupsEdited;
  }

  public get groups(): Nillable<AdminBoxSaleGroups> {
    return this.data.groups;
  }

  public get validityHours(): number {
    return this.data.validityHours ?? AdminBoxSaleDetailsForm.DefaultValidityHours;
  }

  public get id(): Nillable<Guid> {
    return this.data.id;
  }
}

export type AdminBoxSaleDetailsFormGroup = FormGroup<{
  description: FormControl<Nillable<string>>;
  groups: FormControl<Nillable<AdminBoxSaleGroups>>;
  validityHours: FormControl<number>;
}>;
